export const PHONE_PREFIXES = [["+41", "CH"], ["+39", "IT"], ["+49", "DE"], ["+33", "FR"], ["+43", "AT"], ["+423", "LI"], ["+44", "UK"], ["+34", "ES"], ["+1", "US"]];

export const joinPhone = (prefix, number) => `${prefix}${number.replace(/\s/g, "").replace(/^0+/, "")}`;
